export default {
  allergensField: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      margin: '10%'
    }
  },
  spanError: { color: 'red' },

}
